<div class="bomb-game" [class.screen-shake]="internalPhase === 'explosion'">

  <!-- Top bar: counter + inline students + title + actions -->
  <div class="top-bar">
    <span class="q-counter">
      <span class="q-now">{{ getQuestionNum() | arabicNumber:currLang }}</span>
      <span class="q-of">/{{ getTotalQuestions() | arabicNumber:currLang }}</span>
    </span>

    <div class="inline-students">
      <div *ngFor="let student of session?.students"
           class="micro-student"
           [class.is-holder]="student.id === state?.currentHolderId"
           [class.is-exploded]="isStudentExploded(student.id)">
        <app-student-avatar
          [student]="student"
          [size]="32"
          [active]="student.id === state?.currentHolderId">
        </app-student-avatar>
      </div>
    </div>

    <span class="game-label">
      <svg width="16" height="16" viewBox="0 0 64 64" style="vertical-align: -2px; margin-right: 3px;">
        <circle cx="32" cy="38" r="20" fill="#3A3A3A"/>
        <rect x="28" y="12" width="8" height="10" rx="3" fill="#555"/>
        <line x1="32" y1="12" x2="36" y2="4" stroke="#FFA000" stroke-width="2.5" stroke-linecap="round"/>
        <circle cx="36" cy="4" r="3" fill="#FF9800"/>
      </svg>
      {{ currLang === 'ar' ? 'تمرير القنبلة' : 'Bomb Pass' }}
    </span>

    <span class="boom-count" *ngIf="getExplosionCount() > 0">
      <svg width="14" height="14" viewBox="0 0 24 24" style="vertical-align: -1px; margin-right: 2px;">
        <polygon points="12,1 14,8 12,6 16,10 13,9 15,14 12,11 9,14 11,9 8,10 12,6 10,8" fill="#FF9800"/>
        <circle cx="12" cy="12" r="4" fill="#F44336"/><circle cx="12" cy="12" r="2" fill="#FF9800"/>
      </svg>
      {{ getExplosionCount() | arabicNumber:currLang }}
    </span>

    <div class="top-actions">
      <app-game-sound-control></app-game-sound-control>
      <button class="icon-btn" (click)="showInfo = true">
        <span style="font-size:13px;font-weight:700;">?</span>
      </button>
    </div>
  </div>

  <app-game-info-modal *ngIf="showInfo" [gameType]="'bomb_pass'" (close)="showInfo = false"></app-game-info-modal>

  <!-- Hot seat: holder avatar + name + bomb + timer (hidden during explosion/spotlight) -->
  <div class="hot-seat" *ngIf="internalPhase === 'question'">
    <app-student-avatar [student]="currentHolder" [size]="44" [active]="true"></app-student-avatar>
    <span class="hot-seat-name">{{ getHolderName() }}</span>
    <div class="hot-seat-bomb">
      <app-bomb-visual
        [timeLeft]="internalPhase === 'question' ? timerValue : (state?.fuseTime || 10)"
        [isExploding]="false"
        [currLang]="currLang">
      </app-bomb-visual>
    </div>
  </div>

  <!-- Main stage: swaps content per phase, same position -->
  <div class="stage">

    <!-- Holder reveal -->
    <div class="phase-spotlight" *ngIf="internalPhase === 'holder-show'">
      <app-student-spotlight
        [student]="currentHolder"
        [currLang]="currLang"
        [label]="currLang === 'ar' ? 'يحمل القنبلة!' : 'Holding the bomb!'">
      </app-student-spotlight>
    </div>

    <!-- Question -->
    <ng-container *ngIf="internalPhase === 'question' && currentQuestion">
      <app-question-card
        [question]="currentQuestion"
        [selectedOption]="selectedOption"
        (optionSelected)="selectOption($event)">
      </app-question-card>

      <button class="pass-btn" [class.live]="selectedOption" [disabled]="!selectedOption" (click)="submitAnswer()">
        {{ currLang === 'ar' ? 'مرر!' : 'PASS IT!' }}
      </button>
    </ng-container>

    <!-- Safe -->
    <div class="phase-safe" *ngIf="internalPhase === 'result' && lastResult">
      <span class="safe-check">✔</span>
      <span class="safe-word">{{ currLang === 'ar' ? 'آمن!' : 'SAFE!' }}</span>
      <span class="safe-xp" *ngIf="lastResult.xpEarned > 0">+{{ lastResult.xpEarned | arabicNumber:currLang }} XP</span>
    </div>

  </div>

  <!-- Explosion fullscreen -->
  <div class="explosion-overlay" *ngIf="internalPhase === 'explosion'">
    <div class="flash"></div>
    <div class="fire-ring ring-1"></div>
    <div class="fire-ring ring-2"></div>
    <div class="fire-ring ring-3"></div>
    <div class="explosion-center">
      <div class="boom-text">{{ currLang === 'ar' ? 'بوم!' : 'BOOM!' }}</div>
      <div class="boom-sub">{{ currLang === 'ar' ? 'انفجرت!' : 'It exploded!' }}</div>
    </div>
    <div class="debris d-1"></div><div class="debris d-2"></div><div class="debris d-3"></div>
    <div class="debris d-4"></div><div class="debris d-5"></div><div class="debris d-6"></div>
    <div class="debris d-7"></div><div class="debris d-8"></div><div class="debris d-9"></div>
    <div class="debris d-10"></div><div class="debris d-11"></div><div class="debris d-12"></div>
    <div class="ember e-1"></div><div class="ember e-2"></div><div class="ember e-3"></div>
    <div class="ember e-4"></div><div class="ember e-5"></div><div class="ember e-6"></div>
    <div class="ember e-7"></div><div class="ember e-8"></div>
    <svg class="crack-svg" viewBox="0 0 400 800" preserveAspectRatio="none">
      <path class="crack-line c-1" d="M200 400 L180 340 L195 290 L170 230 L185 170 L160 100 L175 30" />
      <path class="crack-line c-2" d="M200 400 L220 330 L210 270 L235 200 L220 130 L240 60" />
      <path class="crack-line c-3" d="M200 400 L150 420 L100 410 L50 430 L10 415" />
      <path class="crack-line c-4" d="M200 400 L250 420 L310 405 L360 425 L400 410" />
      <path class="crack-line c-5" d="M200 400 L190 460 L205 530 L185 600 L200 680 L180 760" />
      <path class="crack-line c-6" d="M200 400 L230 470 L215 540 L240 620 L225 700" />
    </svg>
    <div class="smoke s-1"></div><div class="smoke s-2"></div><div class="smoke s-3"></div>
  </div>
</div>
